export default "__VITE_ASSET__c1f4af2a__"